import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  mainDiv: {
    height: "100%",
    overflowY: "hidden",
    overflowX: "hidden",
    fontFamily: "Manrope !important",
  },
  lineSeparator: {
    width: "100%",
    marginTop: "16px",
    marginBottom: "16px",
    border: "1px solid #E0E2E7",
  },
  sendButton: {
    width: "99px",
    "& span": {
      fontWeight: 700,
      fontSize: "12px",
    },
  },
  messagesScroll: {
    height: "100%",
    overflowY: "auto",
    padding: "8px",
    marginBottom: "8px",
    "&::-webkit-scrollbar": {
      width: "6px",
      borderRadius: "8px",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#EDF5FB",
      borderRadius: "8px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#465869",
      borderRadius: "8px",
    },
  },
  messageTitle: {
    font: "700 12px/19px Manrope",
    color: "#465869",
    marginRight: 2,
  },
  messageSubtitle: {
    font: "300 12px/19px Manrope",
    color: "#465869",
  },
  leftMessageBox: {
    padding: "8px 12px",
    background: "#EDF5FB",
    borderRadius: "0px 8px 8px 8px",
    "& span": {
      color: "#465869",
      overflowWrap: "anywhere",
    },
  },
  rightMessageBox: {
    marginLeft: "auto",
    padding: "8px 12px",
    background: "#308CDB",
    borderRadius: "8px 0px 8px 8px",
    "& span": {
      color: "#FFFFFF",
      overflowWrap: "anywhere",
    },
  },
}));

export default styles;
